/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyList = {
    properties: {
        companies: {
    type: 'array',
    contains: {
        type: 'Company',
    },
    isRequired: true,
},
    },
};